module.exports = __webpack_public_path__ + "db9ef4d9cb435aa81575bfae18b8e74a.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-7.png
// module id = 411
// module chunks = 0